import LegalInfo from './legal-info';

export default LegalInfo;
